import angular from 'angular'
import uiRouter from 'angular-ui-router'
import sharedmomentsComponent from './sharedmoments.component'
import card1 from './card1/card1'
import card2 from './card2/card2'
import card3 from './card3/card3'
import SharedMoments from './sharedmoments.factory'

const sharedmomentsModule = angular.module('sharedmoments', [
        uiRouter,
        card1,
        card2,
        card3
    ])

    .component('sharedmoments', sharedmomentsComponent)

    .factory('SharedMoments', SharedMoments)

    .name

export default sharedmomentsModule



// WEBPACK FOOTER //
// ./client/app/components/home/sharedmoments/sharedmoments.js